export enum EnvironmentSettingEnum {
  NO_CHANGE = 'NO_CHANGE',
  CLEAR_DEBRIS = 'CLEAR_DEBRIS',
  SIMPLE_LAWN = 'SIMPLE_LAWN',
  FULL_LANDSCAPE = 'FULL_LANDSCAPE',
}

export type EnvironmentSetting = `${EnvironmentSettingEnum}`;

export const ENVIRONMENT_SETTING_LABELS: Record<
  EnvironmentSettingEnum,
  string
> = {
  [EnvironmentSettingEnum.NO_CHANGE]: 'No changes',
  [EnvironmentSettingEnum.CLEAR_DEBRIS]: 'Clear debris',
  [EnvironmentSettingEnum.SIMPLE_LAWN]: 'Simple lawn',
  [EnvironmentSettingEnum.FULL_LANDSCAPE]:
    'Full landscaping with trees and plants',
};

export const ENVIRONMENT_SETTING_DESCRIPTIONS: Record<
  EnvironmentSettingEnum,
  string
> = {
  [EnvironmentSettingEnum.NO_CHANGE]: '',
  [EnvironmentSettingEnum.CLEAR_DEBRIS]:
    'Remove all construction debris, trash, and clutter from the scene. Keep the existing ground surfaces but make them clean and tidy.',
  [EnvironmentSettingEnum.SIMPLE_LAWN]:
    'Replace the current ground with a well-maintained green grass lawn. Add simple concrete or paved walkways to the entrance.',
  [EnvironmentSettingEnum.FULL_LANDSCAPE]:
    'Create professional landscaping with green grass lawn, mature trees, decorative shrubs, flower beds, and well-designed pathways. Add appropriate outdoor lighting and landscape features.',
};
